import { Button, Grid, Paper, withStyles } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import InputAdornment from '@material-ui/core/InputAdornment';
import Typography from '@material-ui/core/Typography';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Alert from 'components/Alert';
import { cleanAlert } from 'ducks/alerts';
import reachOKLogo from 'images/brand/REACHok_branco.png';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { connect } from 'react-redux';
import theme from 'source/theme';
import styles from './styles';

const Component = props => {
  const { classes, alert } = props;
  const { cleanAlert } = props;
  const [email, setEmail] = useState('');

  const handleChangeEmail = event => {
    setEmail(event.target.value);
  };

  const handleSubmit = () => {
    //props.passwordForgot(email);
  };

  return (
    <div className={classes.container}>
      <div className={classes.loginArea}>
        <Paper className={classes.paper}>
          <div className={classes.margin}>
            <Alert
              open={alert.message.length !== 0}
              message={alert.message}
              handleClose={cleanAlert}
              placement={{ vertical: 'top', horizontal: 'right' }}
              variant={'error'}
            />

            <Grid container justify="center">
              <Grid item xs={8}>
                <img src={reachOKLogo} style={{ width: '100%' }} alt=""/>
              </Grid>
            </Grid>

            <Divider style={{ marginBottom: '15px' }}/>

            <Grid container spacing={8} justify='center'>
              <Grid xs={10} item>
                <Typography
                  variant="h6" align='center' gutterBottom
                  style={{color: theme.palette.secondary.dark}}
                >
                  Forgot password !
                </Typography>
                <Typography
                  variant="body2" align='justify' gutterBottom
                  style={{color: theme.palette.secondary.dark}}
                >
                  Please insert the email for your account. You will receive an email breefly.
                  Thank you!
                </Typography>
              </Grid>
            </Grid>

            <Divider style={{ marginTop: '15px', marginBottom: '30px' }}/>

            <ValidatorForm onSubmit={handleSubmit}>
              <Grid container className={classes.textInput}>
                <Grid item md={true} sm={true} xs={true}>
                  <TextValidator
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AccountCircle className={classes.iconColor} style={{ fontSize: 30 }}/>
                        </InputAdornment>
                      )
                    }}
                    label="Email"
                    onChange={handleChangeEmail}
                    name="email"
                    value={email}
                    validators={['required', 'isEmail']}
                    errorMessages={['this field is required', 'email is not valid']}
                    fullWidth
                  />
                </Grid>
              </Grid>


              <Grid container justify="center" style={{ marginTop: '30px' }}>
                <Button
                  type="submit"
                  className={classes.textTransformationNone}
                  variant="contained"
                  color="secondary"
                >
                  Submit
                </Button>
              </Grid>
            </ValidatorForm>

          </div>
        </Paper>
      </div>
    </div>
  );
};

Component.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  alert: state.alert
});

const mapDispatchToProps = dispatch => ({
  // passwordForgot(user) {
  //   dispatch(passwordForgot(user));
  // },
  cleanAlert() {
    dispatch(cleanAlert());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Component));
